(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.AddQuoteController = (function(superClass) {
    extend(AddQuoteController, superClass);

    function AddQuoteController(scope, transitions, data, modalInstance) {
      this.scope = scope;
      this.transitions = transitions;
      this.data = data;
      this.modalInstance = modalInstance;
      this.save = bind(this.save, this);
      AddQuoteController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      this.scope.title = 'Add New Quote';
      this.scope.quote = '';
      this.scope.selected = {
        quotee: null
      };
      this.loadScopeData(this.data.getQuotablePersons(), 'quotablePersons');
    }

    AddQuoteController.prototype.save = function() {
      return this.data.saveQuote(this.scope.quote, this.scope.selected.quotee).then((function(_this) {
        return function(response) {
          return _this.closeWithAlert(response.data.status);
        };
      })(this));
    };

    return AddQuoteController;

  })(DialogController);

}).call(this);
